
import {defineComponent} from "vue";
import {maskCEP, maskCNPJ, maskCPF} from "../../mixins";

export default defineComponent({
  props: {
    modelValue: {
      type: String,
      required: false,
      default: "",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    id: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxLength: {
      type: Number,
      required: false,
    },
    minLength: {
      type: Number,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    hasCharacterCounter: {
      type: Boolean,
      required: false,
      default: false,
    },
    mask: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup(props, { emit }) {
    const maskInput = (event: Event) => {
      const input = event.target as HTMLInputElement;

      if (!input.value || input.value === "") {
        emit("update:modelValue", input.value);
        return;
      }

      if (props.mask?.length) {
        if (props.mask.match("##.###.###/####-##")) {
          input.value = maskCNPJ(input.value);
        }
        if (props.mask.match("###.###.###-##")) {
          input.value = maskCPF(input.value);
        }
        if (props.mask.match("#####-###")) {
          input.value = maskCEP(input.value);
        }
        emit("update:modelValue", input.value);
        return;
      }
    };

    return { maskInput };
  },
});
